import React from 'react'
import PropTypes from 'prop-types'

import Lurker from '../../../util/lurker'
import {
  passwordlessLoginApiCall,
  passwordlessLoginApiCallRevalidation,
} from '../../../api/passwordlessLoginApiCall'
import transientErrorsStorage from '../../../util/transientErrorsStorage'
import getSessionTokenInfos from '../../../util/sessionTokenGetter'
import { isAccountRevalidationExperimentOn } from '../../../util/experiments'
import storage from '../../../util/storage'
import {
  LOGIN_METHOD_KEY,
  MAGIC_LINK_LOGIN_METHOD,
  MANDATORY_TIPIFICATION_KEY,
} from '../../../util/global.consts'
import { isValidMustTypify } from '../../../util/account'

const lurker = new Lurker('login')

class MagicLinkValidateTemplate extends React.Component {
  async componentDidMount() {
    const { token, onAccountCompleteData, abTests } = this.props

    lurker.pageLoadEvt()
    const sessionTokens = await getSessionTokenInfos()

    const isMustTypify = await isValidMustTypify()

    const passwordlessLoginApiCaller = isAccountRevalidationExperimentOn(abTests)
      ? passwordlessLoginApiCallRevalidation(token, sessionTokens)
      : passwordlessLoginApiCall(token, sessionTokens, abTests)

    passwordlessLoginApiCaller
      .then(data => {
        const { isTypified } = data

        if (!isTypified && isMustTypify) {
          return onAccountCompleteData()
        }

        this.onSuccess(data)
      })
      .catch(this.onError)
  }

  onSuccess = data => {
    lurker.viewMessageEvt('email_login_success', {
      accounts_method: 'passwordless',
      remote_addr: data.remoteAddress,
      accountId: data.accountId,
    })
    if (this.props.onSuccess) {
      this.props.onSuccess({ ...data, method: MAGIC_LINK_LOGIN_METHOD })
    }
  }

  onError = async (error = {}) => {
    const { response: { status, data = {} } = {} } = error
    const { message } = data || null

    if (status === 401) {
      if (message === 'ACCOUNT_NOT_VALIDATED') {
        lurker.viewMessageEvt('error', {
          accounts_reason: message.toLowerCase(),
          accounts_status_code: status,
        })

        return this.props.onAccountNotValidated(error?.response?.data?.token)
      } else {
        lurker.viewMessageEvt('error', {
          accounts_reason: 'unauthorized',
          accounts_status_code: status,
        })
      }
      lurker.viewMessageEvt('error', {
        accounts_reason: `passwordless_rate_${message ? message.toLowerCase() : 'UNAUTHORIZED'}`,
        accounts_status_code: status,
      })
      if (message === 'PHONE_NOT_VALIDATED') {
        if (this.props.onPhoneNotValidated) {
          lurker.redirectEvt('phone_validation')
          storage.set(LOGIN_METHOD_KEY, MAGIC_LINK_LOGIN_METHOD)
          return this.props.onPhoneNotValidated(data.token)
        }
      } else if (
        message === 'PIN_CODE' &&
        typeof this.props.onChallengePinCodeCall === 'function'
      ) {
        storage.set(LOGIN_METHOD_KEY, MAGIC_LINK_LOGIN_METHOD)
        lurker.redirectEvt('pin_code', {
          type: data.type,
        })
        return this.props.onChallengePinCodeCall(data)
      } else if (message === 'ACCOUNT_TYPING_REQUIRED') {
        const { onAccountCompleteData } = this.props
        lurker.viewMessageEvt('error', {
          accounts_reason: message.toLowerCase(),
          accounts_status_code: status,
          login_type: 'passwordless',
        })

        storage.set(MANDATORY_TIPIFICATION_KEY, true)

        if (onAccountCompleteData) {
          onAccountCompleteData(data.token)
          return
        }
      } else if (message === 'ACCOUNT_MUST_VALIDATE') {
        lurker.viewMessageEvt('error', {
          accounts_reason: message.toLowerCase(),
          accounts_status_code: status,
          login_type: 'passwordless',
        })

        if (this.props.onAccountMustValidate) {
          return this.props.onAccountMustValidate(data.token)
        }
      }
    } else if (status === 429) {
      lurker.viewMessageEvt('error', {
        accounts_reason: 'passwordless_rate_limit_exceeded',
        accounts_status_code: status,
      })
    } else if (status === 410) {
      lurker.viewMessageEvt('error', {
        accounts_reason: `passwordless_${message ? message.toLowerCase() : 'ACCOUNT_INACTIVE'}`,
        accounts_status_code: status,
      })
    } else if (status === 403) {
      lurker.viewMessageEvt('error', {
        accounts_reason: 'passwordless_recaptcha_invalid_token',
        accounts_status_code: status,
      })
    } else if (status) {
      lurker.viewMessageEvt('error', {
        accounts_reason: 'passwordless_unexpected_status_code',
        accounts_status_code: status,
      })
    } else {
      lurker.viewMessageEvt('error', {
        accounts_reason: 'passwordless_unexpected_error',
        accounts_error_message: (error && error.message) || 'unknown',
      })
    }
    await transientErrorsStorage.set('showExpiredTokenError')
    if (this.props.onError) {
      this.props.onError()
    }
  }

  render() {
    return null
  }
}

MagicLinkValidateTemplate.propTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onPhoneNotValidated: PropTypes.func,
  onAccountNotValidated: PropTypes.func,
  onAccountMustValidate: PropTypes.func,
  onChallengePinCodeCall: PropTypes.func,
  token: PropTypes.string,
  abTests: PropTypes.string,
  onAccountCompleteData: PropTypes.func,
}

export default MagicLinkValidateTemplate
